import { createLazyFileRoute } from "@tanstack/react-router";

import { ExplorePage } from "@/features/insights/routes/ExplorePage";

export const Route = createLazyFileRoute("/_auth/_app/insights/explore")({
  component: ExplorePage,
});
